export default "__VITE_ASSET__q7dOKx2$__"